var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlow = function SvgFlow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.3125 1.5H17.1875C17.3438 1.5 17.5 1.38281 17.5 1.1875V0.5625C17.5 0.40625 17.3438 0.25 17.1875 0.25H0.3125C0.117188 0.25 0 0.40625 0 0.5625V1.1875C0 1.38281 0.117188 1.5 0.3125 1.5ZM19.6875 5.875H2.8125C2.61719 5.875 2.5 6.03125 2.5 6.1875V6.8125C2.5 7.00781 2.61719 7.125 2.8125 7.125H19.6875C19.8438 7.125 20 7.00781 20 6.8125V6.1875C20 6.03125 19.8438 5.875 19.6875 5.875ZM17.1875 11.5H0.3125C0.117188 11.5 0 11.6562 0 11.8125V12.4375C0 12.6328 0.117188 12.75 0.3125 12.75H17.1875C17.3438 12.75 17.5 12.6328 17.5 12.4375V11.8125C17.5 11.6562 17.3438 11.5 17.1875 11.5Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flow.fc6d54c1.svg";
export { ForwardRef as ReactComponent };